// Add your custom JS here.
(function($){

  $(document).ready( function() {

    if ( $('.atsgs-hero-section').length) {

      jQuery(document).on( "scroll", function() {

        var offset = jQuery(document).scrollTop();


        $('.atsgs-hero-section .video-mask1').css('width', Math.floor(offset/3) + 'px');
        $('.atsgs-hero-section .video-mask1').css('right', 'calc(12% - ' + Math.floor(offset/6) + 'px)');

        $('.atsgs-hero-section .video-mask2').css('width', Math.floor(offset/3) + 'px');
        $('.atsgs-hero-section .video-mask2').css('right', 'calc(31% - ' + Math.floor(offset/12) + 'px)');

         
      });
    }

    var lastScrollTop = 0;
    $(window).scroll(function() {

      var st = $(this).scrollTop();
      if (st > lastScrollTop){
        if($(document).scrollTop() >= 200)
        {
          $('.main-header').addClass('scroll-header');

        } else {
          $('.main-header').removeClass('scroll-header');
        }
      } else {
        $('.main-header').removeClass('scroll-header');
      }
      lastScrollTop = st;
      
    });

    // mobile menu
    $('header .hamburger-menu-toggle').click(function() {
      if ( $('header .mobile-menu').hasClass('menu-show') ) {
        $('header .mobile-menu').removeClass('menu-show');
        $('body').removeClass('menu-show');
        $(this).removeClass('menu-show');
      } else {
        $('header .mobile-menu').addClass('menu-show');
        $('body').addClass('menu-show');
        $(this).addClass('menu-show');
      }
    });

    $('header.main-header .menu-wrp .main-menu-wrp .menu > li').click(function(){

      if( $(this).hasClass('has-children') ) {

        if ( $(this).hasClass('active') ) {
          $(this).removeClass('active');
          $('header .main-submenu .each-sub-menu').removeClass('active');
        } else {
          $('header.main-header .menu-wrp .main-menu-wrp .menu > li').removeClass('active');
          $(this).addClass('active');
          var title = $(this).find('a').eq(0).attr('title');

          $('header .main-submenu .each-sub-menu').each(function() {
            if( $(this).attr('data-menu') == title ) {
              $(this).addClass('active');
            } else {
              $(this).removeClass('active');
            }
          });
        }

        return false;

      }

    });

    $(document).on('click', 'header .mobile-menu .menu > li.menu-item-has-children > a', function() {

      if ($(this).parent().find('.sub-menu').eq(0).hasClass('menu-show')) {
        $(this).parent().find('.sub-menu').find('li').find('.sub-menu.menu-show').slideToggle();
        $(this).parent().find('.sub-menu').removeClass('menu-show');
      } else {

        $('header .mobile-menu .menu > li > .sub-menu.menu-show').slideToggle();
        $('header .mobile-menu .menu > li > .sub-menu > li > .sub-menu.menu-show').slideToggle();

        $('header .mobile-menu .menu > li .sub-menu').removeClass('menu-show');

        $(this).parent().find('.sub-menu').eq(0).addClass('menu-show');
      }

      $(this).parent().find('.sub-menu').eq(0).slideToggle();


      return false;
      
    });

    $(document).on('click', 'header .mobile-menu .menu > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > a', function() {

      if ($(this).parent().find('.sub-menu').eq(0).hasClass('menu-show')) {
        $(this).parent().find('.sub-menu').eq(0).removeClass('menu-show');
      } else {

        $('header .mobile-menu .menu > li > .sub-menu > li > .sub-menu.menu-show').slideToggle();

        $('header .mobile-menu .menu > li > .sub-menu > li > .sub-menu').removeClass('menu-show');

        $(this).parent().find('.sub-menu').eq(0).addClass('menu-show');
      }

      $(this).parent().find('.sub-menu').eq(0).slideToggle();

      return false
      
    });

    // $('header .mobile-menu .menu li.menu-item-has-children').each(function() {
    //   $(this).append('<span></span>');
    // });

    // case study slider
    if ( $('.case-study-slider > .gb-inside-container').length) {
      $('.case-study-slider > .gb-inside-container').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: false,
        dots: true,
      }); 
    } 

    // testimonial slider
    if ( $('.testimonial-slider > .gb-inside-container').length) {
      $('.testimonial-slider > .gb-inside-container').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        dots: false,
      }); 
    } 


    // tab section
    var active_tab_item = 1;

    $('.atsgs-services-tab-section .tab-item').click(function() {
      if( !$(this).hasClass('active') ) {
        var data_tab = $(this).attr('data-tab');
        active_tab_item = Number(data_tab) - 1;
        if( active_tab_item < 1 ) {
          active_tab_item = 1;
        }

        $('.atsgs-services-tab-section .tab-item').removeClass('active');
        $('.atsgs-services-tab-section .tab-content').removeClass('active');
        $(this).addClass('active');

        $('.atsgs-services-tab-section .tab-content').each(function() {
          if( $(this).attr('data-tab') == data_tab ) {
            $(this).addClass('active');
          } else {
            $(this).removeClass('active');
          }
        });
      }
    });

    if ( $('.atsgs-services-tab-section').length) {

      $('.atsgs-services-tab-section .tab-item').each(function() {
        if($(this).hasClass('active')) {
          active_tab_item = $(this).attr('data-tab');
        }
      });

      function tab_animi() {

        setTimeout(function(){
          active_tab_item = active_tab_item + 1;

          if( active_tab_item > 4 ) {
            active_tab_item = 1;
          }

          $('.atsgs-services-tab-section .tab-content').removeClass('active');
          $('.atsgs-services-tab-section .tab-item').removeClass('active').removeClass('selected');

          $('.atsgs-services-tab-section .tab-content').each(function() {
            if( $(this).attr('data-tab') == active_tab_item ) {
              $(this).addClass('active');
            } else {
              $(this).removeClass('active');
            }
          });
          $('.atsgs-services-tab-section .tab-item').each(function() {
            if( $(this).attr('data-tab') == active_tab_item ) {
              $(this).addClass('active');
            } else {
              $(this).removeClass('active');
            }
          });

          setTimeout(function() {
            $('.atsgs-services-tab-section .tab-item').each(function() {
              if( $(this).hasClass('active') ) {
                $(this).addClass('selected');
              }
            });
          }, 100);

          tab_animi();

        }, 5000);
      }

      // tab_animi();

    }

    $('.atsgs-services-tab-mobile-section .tab-item .tab-title').click(function() {

      if (!$(this).parent().parent().hasClass('active')) {
        $('.atsgs-services-tab-mobile-section .tab-item').removeClass('active');
        $(this).parent().parent().addClass('active');
      } else {
        $('.atsgs-services-tab-mobile-section .tab-item').removeClass('active');
      }

    });

    if( $('.atsgs-scroll-tab').length ) {
      $('.atsgs-scroll-tab .tab-section .tab-item').click(function() {
        var data_tab = $(this).attr('data-tab');

        if( !$(this).hasClass('active') ) {

          $(this).parent().parent().find('.tab-item').each(function(){
            $(this).removeClass('active');
          });

          $(this).addClass('active');

          $(this).parent().parent().parent().find('.tab-content').eq(0).find('.item-content').each(function() {
            $(this).removeClass('active');
            if ( data_tab == $(this).attr('data-tab') ) {
              $(this).addClass('active');
            } else {
              $(this).removeClass('active');
            }
          });
        }

      });
    }

    if( $('.atsgs-secondary-menu').length ) {
      $('.atsgs-secondary-menu .menu-item').click(function() {
        var href = $(this).find('a').eq(0).attr('href');

        if (href != '#undefined' && jQuery(href).length){
          jQuery('html, body').animate({
            scrollTop: jQuery(href).offset().top - 130
          }, 500); 
        }

        return false;
      });
    }

    jQuery(document).on( "scroll", function() {
      if (jQuery('.atsgs-secondary-menu').length ) {
        jQuery('.atsgs-secondary-menu .menu-item').each(function() {
          var href = $(this).find('a').eq(0).attr('href');

          if ( (jQuery(document).scrollTop() > ( jQuery(href).offset().top - 135 )) 
            && (jQuery(document).scrollTop() < (jQuery(href).offset().top + jQuery(href).height() ) ) ) {
            jQuery('.atsgs-secondary-menu .menu-item').removeClass('active');
            $(this).addClass('active');
          } 

          if ( (jQuery(document).scrollTop() < (jQuery('.hero-section').offset().top + jQuery('.hero-section').height() ) ) )  {
            jQuery('.atsgs-secondary-menu .menu-item').removeClass('active');
          }
        });
      }
    });

    $('.main-submenu .menu-close').click(function() {
      $('.main-submenu .each-sub-menu').removeClass('active');
      $('header.main-header .menu-wrp .main-menu-wrp .menu > li').removeClass('active');
    });

    $('body').click(function(e) {
      if(!e.target.classList.contains('main-submenu') && $(e.target).parents('.main-submenu').length === 0) {
        $('.main-submenu .each-sub-menu').removeClass('active');
        $('header.main-header .menu-wrp .main-menu-wrp .menu > li').removeClass('active');
      }
    });

    $(document).keydown(function(e) {
      if (e.keyCode == 27) { 
        $('.main-submenu .each-sub-menu').removeClass('active');
        $('header.main-header .menu-wrp .main-menu-wrp .menu > li').removeClass('active');
      }
    });


    if ( $('.atsgs-download-slider .slider-wrp').length) {
      $('.atsgs-download-slider .slider-wrp').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        dots: false,
        responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        }]
      }); 
    } 

    if ( $('.atsgs-blog-slider .slider-wrp').length) {
      $('.atsgs-blog-slider .slider-wrp').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        dots: false,
        responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        }]
      }); 
    } 

    if ( $('.atsgs-video-slider .slider-wrp').length) {
      $('.atsgs-video-slider .slider-wrp').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        dots: false,
        responsive: [{
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        }]
      }); 
    }

    // search
    $('header .header-wrp .search-wrp').click(function() {

      if ( !$('header .search-container').hasClass('search-show') ) {
        $('header .search-container').addClass('search-show');
        $(this).addClass('search-show');
      } else {
        $('header .search-container').removeClass('search-show');
        $(this).removeClass('search-show');
      }

    }); 

    $('header .search-container .search-close').click(function(){
      $('header .search-container').removeClass('search-show');
      $('header .header-wrp .search-wrp').removeClass('search-show');
    });

    $('header .search-container .search-wrp .search-icon').click(function(){
      $('header .search-container .search-wrp .search-form-wrp form').submit();
    });

    // iframe auto height
    if ( jQuery('#pardot-form-iframe').length ) {
      jQuery('#pardot-form-iframe').seamless({
        fallbackText: 'In order to submit the form, please ensure that "allow all cookies" has been selected.',
        fallbackStyles: [ 'padding: 15px', 'border: none', 'border-radius: 0px', 'color: #000000', 'background-color: #d9edf7' ],
        fallbackLinkText: ' ',
        fallbackLinkAfter: ' ',
        fallbackLinkStyles: [ 'display: none' ]
      });
    }

    if ( $('.atsgs-students-testimonial-slider > .gb-inside-container').length) {
      $('.atsgs-students-testimonial-slider > .gb-inside-container').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: true,
        dots: true
      }); 
    }

    if ( $('.atsgs-archive-page .blog-spotlight-slider .slider-wrp').length) {
      $('.atsgs-archive-page .blog-spotlight-slider .slider-wrp').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        infinite: true,
        arrows: false,
        dots: true
      }); 
    }

    // faq section
    $('.atsgs-faq-section .each-item .faq-header').click(function() {

      if( $(this).parent().parent().hasClass('active') ) {
        $(this).parent().parent().removeClass('active');
      } else {
        $('.atsgs-faq-section .each-item').removeClass('active');
        $(this).parent().parent().addClass('active');
      }
    });

    // $('.core-values-section .items-wrapper > .gb-grid-column').hover(function() {
    //   $('.core-values-section .items-wrapper > .gb-grid-column').removeClass('active').addClass('activated');
    //   $(this).addClass('active'); 
    // }, function(){
    //   $('.core-values-section .items-wrapper > .gb-grid-column').removeClass('active').removeClass('activated');
    // });

    $('.core-values-section .items-wrapper > .gb-grid-column').on('mouseenter touchstart', function() {
      $('.core-values-section .items-wrapper > .gb-grid-column').removeClass('active').addClass('activated');
      $(this).addClass('active');
  });
  
  $('.core-values-section .items-wrapper > .gb-grid-column').on('mouseleave touchend', function() {
      $('.core-values-section .items-wrapper > .gb-grid-column').removeClass('active').removeClass('activated');
  });

  });

})(jQuery);
